"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var PreviewSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M12.0002473,7.03547981 L12,5 L5.9989067,5 L5.9989067,14 L12.0010933,14 L12.001089,13.9643996 C11.8374407,13.9878602 11.670138,14 11.5,14 C9.56700338,14 8,12.4329966 8,10.5 C8,8.56700338 9.56700338,7 11.5,7 C11.6698464,7 11.836867,7.01209818 12.0002473,7.03547981 Z M13,13.6631844 L13,14 C13,14.5522847 12.5527742,15 12.0010933,15 L5.9989067,15 C5.44722576,15 5,14.5522847 5,14 L5,5 C5,4.44771525 5.44722576,4 5.9989067,4 L12,4 C12.5522847,4 13,4.44771525 13,5 L13,7.33681558 C14.1824737,7.89854755 15,9.10380202 15,10.5 C15,11.2861676 14.7407982,12.0117953 14.3031923,12.5960855 L15.8535534,14.1464466 C16.0488155,14.3417088 16.0488155,14.6582912 15.8535534,14.8535534 C15.6582912,15.0488155 15.3417088,15.0488155 15.1464466,14.8535534 L13.5960855,13.3031923 C13.4107512,13.441999 13.2111965,13.5628559 13,13.6631844 L13,13.6631844 Z M11.5,13 C12.8807119,13 14,11.8807119 14,10.5 C14,9.11928813 12.8807119,8 11.5,8 C10.1192881,8 9,9.11928813 9,10.5 C9,11.8807119 10.1192881,13 11.5,13 Z" })));
};
PreviewSmall.displayName = 'PreviewSmall';
exports.default = PreviewSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=PreviewSmall.js.map